import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { noopVoid } from 'reactApp/utils/helpers';

export const renderPopupMobileAppQR = ({ onClose = noopVoid, isDark = false, url }) =>
    openPopupHelper({ popupName: popupNames.MOBILE_APP_QR, data: { isDark, url }, onClose });
